import { en } from './_en';
import { es } from './_es';
import { createTranslationsHook } from './createTranslationsHook';

export const useTranslations = createTranslationsHook({ en, es });
